import { ACTIONS_DETMIR } from '../actions/detmir';

export const detmir = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_DETMIR.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_DETMIR.CHANGE_PRODUCT: {
      const { product } = action;

      return { ...state, byId: { ...state.byId, [product.offer_id]: { ...product } } };
    }
    default:
      return state;
  }
};
